import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NgClass, NgFor, NgIf, NgStyle } from "@angular/common";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { Observable, firstValueFrom } from "rxjs";
import { AuthService } from "src/app/security/auth.service";
import { Tickets } from "src/app/shared/model/tickets/tickets.model";
import { SweetAlertComponent } from "src/app/shared/SweetMesssage";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { MensajesFijosEnum } from "src/app/utilerias/enums/mensajes-fijos-enum";
import { TicketsService } from "../../tickets.service";
import { ColumnaTicketsBaseComponent } from "../../tickets-comun/columna-tickets-base.component";

@Component({
  selector: "app-notificacion-cte-ticket",
  standalone: true,
  templateUrl: "./notificacion-cte-ticket.component.html",
  styleUrls: ["./notificacion-cte-ticket.component.css"],
  imports: [MatIcon, MatTooltip, NgClass, NgFor, NgIf, NgStyle],
})
export class NotificacionCteTicketComponent extends ColumnaTicketsBaseComponent {
  idUsuarioEnSession: number | null = null;

  constructor(
    mensaje: SweetAlertComponent,
    service: TicketsService,
    router: Router,
    private readonly authS: AuthService
  ) {
    super(mensaje, service, router);
  }

  llamado(): void {
    void this.executeLoad();
  }

  private async executeLoad(): Promise<void> {
    try {
      await this.ensureSessionUserId();
    } catch {
      this.list = [];
      this.numPaginasEvent.emit([0, this.position, 0]);
      this.emitPagination(0, 0);
      this.mensaje.showSwal("error-message", MensajesFijosEnum.ERROR_SERVIDOR);
      return;
    }

    const hasFilters =
      !!this.nombreCorto?.trim() ||
      !!this.fechaSeleccionada ||
      !!this.areaSeleccionada ||
      !!(this.numero && this.numero > 0);

    this.tickets = new Tickets();
    this.tickets.id_estatus = this.estatusSolicitud;
    this.tickets.id_ticket = this.numero && this.numero > 0 ? this.numero : null;
    this.tickets.asunto = this.nombreCorto;
    this.tickets.fechaSolicitud = this.fechaSeleccionada ? new Date(this.fechaSeleccionada) : null;
    this.tickets.id_area = this.areaSeleccionada?.id ?? null;

    if (hasFilters || (this.regXPagina ?? 0) > 0) {
      this.cargarSolicitudesFiltradas(this.tickets);
      return;
    }

    this.cargarSolicitudesPorEstatus();
  }

  protected consultarPorEstatus(ticket: Tickets): Observable<any> {
    return this.service.obtenerTicketsDelUsuarioPorEstatus(ticket);
  }

  protected consultarFiltrados(consulta: ConsultaList<Tickets>): Observable<any> {
    return this.service.obtenerTicketsDelUsuarioFiltroPaginacion(consulta);
  }

  /** El cliente sólo consulta los tickets que él solicitó. */
  protected override completarConsulta(ticket: Tickets): void {
    ticket.id_UsuarioSolicito = this.idUsuarioEnSession ?? 0;
  }

  protected mostrarDetalleTicket(datosTicket: Tickets): void {
    this.router.navigate(["/TICKETS/DetalleWidget", datosTicket.id_ticket], {
      state: {
        ticket: datosTicket,
        returnUrl: "/TICKETS/Cte",
        viewMode: "client",
      },
    });
  }

  private async ensureSessionUserId(): Promise<number> {
    if (this.idUsuarioEnSession) {
      return this.idUsuarioEnSession;
    }

    const session = await firstValueFrom(this.authS.getSesion());
    this.idUsuarioEnSession = Number(session?.usuario?.id ?? 0);

    if (!this.idUsuarioEnSession) {
      throw new Error("SESSION_USER_MISSING");
    }

    return this.idUsuarioEnSession;
  }
}
